<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemRecycleMode} from "@/modules/redactor/models/item/recycle/ItemRecycleMode";

export default {
  name: "r-item-recycle-mode",
  props: {
    model: VueTypes.instanceOf(ItemRecycleMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemRecycleMode.getValues();
    }
  }
}
</script>